  import React, { StrictMode } from 'react';
  import ReactDOM from 'react-dom/client';
  import { BrowserRouter, RouterProvider } from 'react-router-dom';
  import router from './assets/router';
  import { ContextProvider } from './Contexts/ContextProvider';
import "./index.css" ; 
import 'bootstrap/dist/css/bootstrap.min.css';

  const root = ReactDOM.createRoot(document.getElementById('root'));  
  
  root.render(
      
        <ContextProvider>

        <RouterProvider router={router}/>

        </ContextProvider>

     
    
  );  

